export default __webpack_public_path__ + "static/automatizacion-0cf658cd90ff64d38f2dfe225c4d8b84.png";